/**
 * @desc: - 分页
 * @param  {[string]} className   [顶层class]
 * @param  {[object]} val         [存放标题，图片路径等的数组]
 * @author: circle
 */

import React from 'react';
import { DOMAIN } from '../../constants/config'

export default class gameImg extends React.Component {
	constructor(props){
		super(props)
    this.openUrl = this.openUrl.bind(this);
    this.urlMapping = {
      pt: DOMAIN + 'ptgame/play/',
      ag: DOMAIN + 'aggame/play/',
      bbin: DOMAIN + 'livegame/bbinplay/',
    }
	} 

  openUrl(gameId){
    const { platform, active, reload } = this.props;
    window.open(this.urlMapping[platform] + gameId);
    if (!active) {
      window.setTimeout(() => reload(platform), 5000)
    }
  }  

	render(){
      let {val, platform} = this.props;
      return (
        <li className={platform + '-item-card item-card'}>
          <a title = {val.name} className='pointer' onClick={this.openUrl.bind(this, val.id)}>
            <i className={val.is_hot ? 'pt-hot' : ''}></i>
            <img src={val.picture}/>
            <p className="item-card-title" >{val.name}</p>
            <p className="heightLight"></p>
          </a>
        </li>
		)

	}
}